import { ComponentSchemaManagerContainer } from '~/app/components/knowledgeBase/componentSchemaManager';

export const KnowledgeBaseContainer = () => <ComponentSchemaManagerContainer />;
